export function NotFound({ children }: { children?: any }) {
	return children || <p>What you are looking for doesn't seem to exist.</p>;
}
